/* Nuvoriel: add to basket without leaving the page.
   Default: opens the theme's cart drawer. data-nv-silent: updates the basket quietly. */
(function () {
  if (window.__nvCart) return;
  window.__nvCart = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function sectionList(drawer) {
    try {
      if (drawer && typeof drawer.getSectionsToRender === 'function') return drawer.getSectionsToRender();
    } catch (err) {}
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
  }

  function swapSections(list, sections) {
    if (!sections) return;
    list.forEach(function (s) {
      var html = sections[s.id];
      if (!html) return;
      var target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (!target) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var source = doc.querySelector(s.selector || '.shopify-section');
      if (source) target.innerHTML = source.innerHTML;
    });
  }


  /* Priority shipping switch in the cart drawer */
  window.nvPri = function (input) {
    var drawer = document.querySelector('cart-drawer');
    var id = input.getAttribute('data-variant');
    var on = input.checked;
    var list = sectionList(drawer);
    var payload = on ? { items: [{ id: Number(id), quantity: 1 }] } : { id: String(id), quantity: 0 };
    payload.sections = list.map(function (s) { return s.id; }).join(',');
    payload.sections_url = window.location.pathname;
    input.disabled = true;
    fetch(root() + (on ? 'cart/add.js' : 'cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          input.checked = !on;
          window.alert(data.description || data.message || 'Priority shipping could not be updated.');
          return;
        }
        if (drawer && data.sections) swapSections(list, data.sections);
        else window.location.reload();
      })
      .catch(function () { window.location.href = root() + 'cart'; })
      .finally(function () { input.disabled = false; });
  };

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form.nv-form') : null;
    if (!form) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return; // let the form submit normally

    e.preventDefault();
    var silent = form.hasAttribute('data-nv-silent');
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    var list = sectionList(drawer);
    var body = new FormData(form);
    body.append('sections', list.map(function (s) { return s.id; }).join(','));
    body.append('sections_url', window.location.pathname);

    var added = false;
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) {
          window.alert(r.data.description || r.data.message || 'This item could not be added to your basket.');
          return;
        }
        added = true;
        try {
          drawer.classList.remove('is-empty');
          if (silent) {
            swapSections(list, r.data.sections);
          } else {
            drawer.renderContents(r.data);
          }
        } catch (err) {
          if (!silent) window.location.href = root() + 'cart';
        }
      })
      .catch(function () { if (!silent) window.location.href = root() + 'cart'; })
      .finally(function () {
        if (!btn) return;
        btn.removeAttribute('aria-busy');
        if (added && form.getAttribute('data-nv-added')) {
          btn.textContent = form.getAttribute('data-nv-added');
        } else {
          btn.disabled = false;
        }
      });
  });
})();
